import moment from 'moment';
import history from 'libs/history';
import { message } from 'antd';
const getDuration = (time: number) => {
    if (!time) return '-';
    const du = moment.duration(time, 's');
    const mins: any = du.get('minutes') + 'm',
        ss: any = du.get('seconds') + 's';

    return mins + ss;
};
const getQueryByName = (name = '', url = window.location.search) => {
    const reg = new RegExp('[?&]' + name + '=([^&#]+)');
    const query = url.match(reg);
    return query ? decodeURIComponent(query[1]) : null;
};
const replaceQuery = (name = '', value = '', url = window.location.href) => {
    const query = getQueryByName(name);
    const newValue = encodeURIComponent(value);
    if (!query) {
        const reg = /[?]([^#]+)/;
        let search = url.match(reg);
        if (search) {
            const newSearch = search[0] + `&${name}=${newValue}`;
            return url.replace(search[0], newSearch);
        }
        const resultUrl = url.match(/[^#]+/);
        if (resultUrl) {
            return url.replace(
                resultUrl[0],
                resultUrl[0] + `?${name}=${newValue}`
            );
        }
        return url;
    }
    return url.replace(encodeURIComponent(query), newValue);
};
export const goLogin = () => {
    console.log('go login');
    history.push('/admin/login');
};
const getRedirectUrl = () => {
    const redirectUrl = getQueryByName('redirectUrl');
    if (redirectUrl) return decodeURIComponent(redirectUrl);
    return '';
};
const download = (resp: any, name: string) => {
    if (!(resp instanceof Blob)) {
        console.log('download', resp);
        message.warning('下载失败');
        return;
    }
    const url = URL.createObjectURL(resp);
    const downloadElement = document.createElement('a');
    downloadElement.href = url;
    const filename = name;
    downloadElement.download = decodeURIComponent(filename);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(url);
};
export const formatNumber = (num: number): string => {
    let str = String(num);
    let i = 0;
    let length = str.length;
    while (i < length - 1) {
        const index = length - 1 - i;
        if ((i + 1) % 3 === 0) {
            str = str.slice(0, index) + ',' + str.slice(index);
            i++;
        }
        i++;
    }
    return str;
};

// export const serialize = (obj: { [key: string]: any }) => {
//   let str = [];
//   for (let key in obj) {
//     if (obj.hasOwnProperty(key)) {
//       str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
//     }
//   }
//   return str.join('&');
// };

/**
 * 获取日期周几
 * @param date 日期 或者 日期字符串
 * @returns
 */
export const getWeek = (date: number | Date): string => {
    // 参数时间戳
    let week = moment(date).day();
    switch (week) {
        case 1:
            return '周一';
        case 2:
            return '周二';
        case 3:
            return '周三';
        case 4:
            return '周四';
        case 5:
            return '周五';
        case 6:
            return '周六';
        case 0:
            return '周日';
        default:
            return '';
    }
};
/**
 * 路由 search 字符串转Json
 * @param searchStr query字符串 (?key=value&key1=value1)
 */
export const locationQueryToJson = (searchStr: string) => {
    if (searchStr.indexOf('?') > -1) {
        searchStr = searchStr.substr(1, searchStr.length);
    }

    let obj: any = {},
        pairs = searchStr.split('&');
    pairs.forEach((pair: string, i: number) => {
        const _pairArr = pair.split('=');
        obj[decodeURIComponent(_pairArr[0])] = decodeURIComponent(_pairArr[1]);
    });
    return obj;
};

/**
 * 路由 search Json转字符串
 * @param json query 对象
 * @param isChar 是否带字符?
 * @returns string
 */
export const locationJsonToQuery = (
    json: any,
    isChar: boolean = false
): string => {
    return `${isChar ? '?' : ''}${Object.keys(json)
        .map((key: string) => {
            return (
                encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
            );
        })
        .join('&')}`;
};

/**
 * 将分钟数转成时间格式字符串
 * @param m 分钟数
 */
export const formatMinute = (m: number) => {
    const h = Math.floor(m / 60);
    m = m % 60;
    return [h, m]
        .map(n => {
            let str = String(n);
            if (str.length < 2) {
                str = '0' + str;
            }
            return str;
        })
        .join(':');
};

/**
 * 判断一个值是否为空
 * @param val
 * @returns boolean
 */
export const isEmpty = (val: any) => {
    if (typeof val === 'undefined' || val === null || val === '') {
        return true;
    } else {
        return false;
    }
};

// Unicode 字符串编码
// ucs-2 string to base64 encoded ascii
export function utoa(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
}
// base64 encoded ascii to ucs-2 string
export function atou(str: string) {
    return decodeURIComponent(escape(window.atob(str)));
}

var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
var chnUnitChar = ['', '十', '百', '千'];
function sectionToChinese(section: number) {
    var strIns = '',
        chnStr = '';
    var unitPos = 0;
    var zero = true;
    while (section > 0) {
        var v = section % 10;
        if (v === 0) {
            if (!zero) {
                zero = true;
                chnStr = chnNumChar[v] + chnStr;
            }
        } else {
            zero = false;
            strIns = chnNumChar[v];
            strIns += chnUnitChar[unitPos];
            chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
    }
    return chnStr;
}

function numberToChinese(num: number) {
    var unitPos = 0;
    var strIns = '',
        chnStr = '';
    var needZero = false;

    if (num === 0) {
        return chnNumChar[0];
    }

    while (num > 0) {
        var section = num % 10000;
        if (needZero) {
            chnStr = chnNumChar[0] + chnStr;
        }
        strIns = sectionToChinese(section);
        strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
        chnStr = strIns + chnStr;
        needZero = section < 1000 && section > 0;
        num = Math.floor(num / 10000);
        unitPos++;
    }

    return chnStr;
}

// 模版字符串
// const template = "{{name}}, 你好";
// const context = { name: "bugu" };
export function render(template: string, context: { [key: string]: any }) {
    return template.replace(
        /\{\{(.*?)\}\}/g,
        (match, key) => context[key.trim()]
    );
}

export const decodeUrlSearchToObject = (searchStr: string) => {
    return decodeURIComponent(searchStr)
        .replace('?', '')
        .split('&')
        .reduce((p: any, c: string) => {
            let [k, v] = c.split('=');
            p[k] = ((str: string) => {
                if (str?.includes(',')) {
                    return str.split(',');
                }

                return str;
            })(v);
            return p;
        }, {});
};

export const encodeObjectToUrlSearch = (obj: any) => {
    return Object.keys(obj)
        .filter(k => !!obj[k])
        .map(k => `${k}=${encodeURIComponent(obj[k])}`)
        .join('&');
};
